module.exports = __webpack_public_path__ + "static/media/pasticceria_4.fbbe210f.jpg";